import { http, request } from "./request.js";

async function me() {
    return await request("/auth/me", {}, "GET");
}

async function login(data) {
    return await http({ url: "/auth/login", data, method: "POST" });
}

async function forget(data) {
    return await http({ url: "/auth/forget-password", data, method: "POST" });
}

async function recover(data) {
    return await http({ url: "/auth/recover-password", data, method: "POST" });
}

async function logout(refreshToken = "") {
    return await request("/auth/logout", { refreshToken: refreshToken });
}

export { me, login, forget, recover, logout };
